import {
    GETRULEMAPPINGCHECK_SUCCESS,
    GETRULEMAPPINGCHECK_FAILED,
    RESET_GETRULEMAPPINGCHECK,
    LOADING_GETRULEMAPPINGCHECK,
    NETWORK_ERROR_GETRULEMAPPINGCHECK
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETRULEMAPPINGCHECK:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETRULEMAPPINGCHECK_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETRULEMAPPINGCHECK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETRULEMAPPINGCHECK:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETRULEMAPPINGCHECK:
            return (state = initialState);
        default:
            return state;
    }
};
